import React from "react";
import "../PracticeArea/AreaField.css";
import {
  FaBalanceScale,
  FaBuilding,
  FaHome,
  FaMedkit,
  FaCopyright,
  FaUsers,
  FaGavel,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const areaData = [
  {
    id: "corporate-securities", // Added ID for routing
    title: "Corporate & Securities",
    description:
      "Mergers & acquisitions, business formation, compliance, securities regulations",
    icon: <FaBuilding className="member-icon" />,
    image: "/demo.webp",
    alt: "Corporate & Securities",
  },
  {
    id: "real-estate", // Added ID for routing
    title: "Real Estate Law",
    description: "Property transactions, zoning issues, landlord disputes",
    icon: <FaHome className="member-icon" />,
    image: "/realestate.webp",
    alt: "Real Estate Law",
  },
  {
    id: "healthcare", // Added ID for routing
    title: "Healthcare Law",
    description: "Regulatory compliance, patient rights, medical malpractice",
    icon: <FaMedkit className="member-icon" />,
    image: "/health.webp",
    alt: "Healthcare Law",
  },
  {
    id: "family", // Added ID for routing
    title: "Family Law",
    description: "Divorce, child custody, adoption, prenuptial agreements",
    icon: <FaUsers className="member-icon" />,
    image: "/family.webp",
    alt: "Family Law",
  },
  {
    id: "intellectual-property", // Added ID for routing
    title: "Intellectual Property",
    description: "Patents, trademarks, copyrights, trade secrets protection",
    icon: <FaCopyright className="member-icon" />,
    image: "/property.webp",
    alt: "Intellectual Property",
  },
  {
    id: "employment", // Added ID for routing
    title: "Employment Law",
    description: "Workplace rights, wrongful termination, harassment claims",
    icon: <FaUsers className="member-icon" />,
    image: "/employ.webp",
    alt: "Employment Law",
  },
];

const AreaField = () => {
  return (
    <>
      <ul className="list-members">
        {areaData.map((area, index) => (
          <li className="member" key={index}>
            <Link to={`/practicearea/${area.id}`} className="member-link">
              <div className="member-image">
                <img src={area.image} alt={area.alt} />
              </div>
              <div className="member-info">
                <div className="member-heading">
                  {area.icon}
                  <h3>{area.title}</h3>
                </div>
                <p>{area.description}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default AreaField;
